module.exports = __webpack_public_path__ + "static/cauldron_of_rebirth-212c15d393f7681d55fc400d07194b44.png";